import { default as CE_usePluginActionResponseTabs } from "ce/PluginActionEditor/components/PluginActionResponse/hooks/usePluginActionResponseTabs";

function usePluginActionResponseTabs() {
  return CE_usePluginActionResponseTabs();
}

export default usePluginActionResponseTabs;
